import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./header/Header";
import SEOLayout from "./SEOLayout";

const HeaderFooterLayout = () => {
  return (
    <>
      <SEOLayout />
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default HeaderFooterLayout;
